import { useSelector } from 'react-redux';
import { selectPreviewHTML } from '../../redux/queryResults';
import { QuestionViewProps, tabToSelectView } from './models';
import './QuestionView.scss';

export const QuestionView = ({hidden}: QuestionViewProps): JSX.Element => {
  const previewHTML = useSelector(selectPreviewHTML);

  return (
    <div id='nqt-question-view' className={`nqt-question-view${hidden ? ' d-none' : ''}`} tabIndex={0} onKeyDown={tabToSelectView}>
      <div className="nqt-question-view--content"
        dangerouslySetInnerHTML={{__html: previewHTML ? previewHTML : ''}}>
      </div>
    </div>
  );
};

export default QuestionView;